import { cva } from "class-variance-authority"

export const tagVariants = cva(
  "inline-flex items-center rounded-full px-3 py-1 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "bg-amber-50 text-amber-900 border border-amber-200 hover:bg-amber-100",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

// Type for tag variants (simplified to just default)
type TagVariant = 'default';

// Simplified tag mapping - always returns default variant
export const getTagVariant = (_tag: string): TagVariant => {
  return 'default';
};

// Badge-compatible variant mapping for simpler badge usage
export const getBadgeVariant = (_tag: string): 'default' | 'secondary' | 'destructive' | 'outline' => {
  return 'secondary';
};